import { getConfig } from './config';

export const HELPDESK_APP_URL = getConfig().helpdeskAppUrl;
